export default __webpack_public_path__ + "static/logo-ad8c648963cd23b64899a6960750c8fb.svg";